module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_39406729_L-small-c0110f66d188e741164e1ba86ec22e39.jpg";